import { render, staticRenderFns } from "./PostReply.vue?vue&type=template&id=17ddcc3a&scoped=true"
import script from "./PostReply.vue?vue&type=script&lang=js"
export * from "./PostReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddcc3a",
  null
  
)

export default component.exports